/* WDN CopyOnClick */
var WDN = WDN || {};

if (typeof WDN.CopyOnClick === "undefined") {
  WDN.CopyOnClick = (function () {
    var CopyOnClick = function (config) {
      this.config = config;
      this.targets = document.querySelectorAll(config.selector);
      this.init();
    };

    CopyOnClick.prototype.assignTargets = function () {
      this.targets = [];
      var targetElements = document.querySelectorAll(this.config.selector);
      targetElements.forEach(function (element) {
        this.targets.push({
          element: element,
          content: element.innerText,
        });
      }, this);
    };

    CopyOnClick.prototype.copyText = function (text) {
      if (typeof text === "undefined") return;
      navigator.clipboard.writeText(text);
    };

    CopyOnClick.prototype.getTargetConfig = function (element) {
      if (!element) return;
      return this.targets.filter(function (target) {
        return target.element === element;
      })[0];
    };

    CopyOnClick.prototype.targetOnClick = function (e) {
      var target = e.currentTarget;
      var targetConfig = this.getTargetConfig(target);
      if (!targetConfig) return;
      this.copyText(targetConfig.content);

      target.classList.add("text-copied");

      setTimeout(function () {
        target.classList.remove("text-copied");
      }, 350);

      if (typeof this.config.onCopy !== "function") return;
      this.config.onCopy(targetConfig);
    };

    CopyOnClick.prototype.bindTargets = function () {
      this.targets.forEach(function (target) {
        target.element.addEventListener("click", this.targetOnClick.bind(this));
      }, this);
    };

    CopyOnClick.prototype.init = function () {
      this.assignTargets();
      this.bindTargets();
    };

    return CopyOnClick;
  })();
}

new WDN.CopyOnClick({
  selector: "[data-discount-code] em",
  onCopy: false, // callback
});

/* Video Play button logic */
(function () {
  var nodes = {
    videoTriggers: document.querySelectorAll("[data-play-video]"),
  };

  var VideoTrigger = function (trigger) {
    this.id = trigger.getAttribute("data-play-video");
    this.trigger = trigger;
    this.video = document.querySelector("[data-video='" + this.id + "']");
    this.videoIsPlaying = false;
    this.init();
  };

  VideoTrigger.prototype.updateAttribute = function () {
    this.trigger.setAttribute("data-video-playing", this.videoIsPlaying);
  };

  VideoTrigger.prototype.handleVideoClick = function () {
    if (this.videoIsPlaying) {
      this.video.pause();
    } else {
      this.video.play();
    }

    this.videoIsPlaying = !this.videoIsPlaying;
    this.updateAttribute();
  };

  VideoTrigger.prototype.handlePauseEvent = function () {
    this.videoIsPlaying = false;
    // Prevents showing icon when changing video timeline (registers pause event)
    setTimeout(this.updateAttribute.bind(this), 200);
  };

  VideoTrigger.prototype.handlePlayEvent = function () {
    this.videoIsPlaying = true;
    this.updateAttribute();
  };

  VideoTrigger.prototype.bind = function () {
    this.trigger.addEventListener("click", this.handleVideoClick.bind(this));
    this.video.addEventListener("pause", this.handlePauseEvent.bind(this));
    this.video.addEventListener("play", this.handlePlayEvent.bind(this));
  };

  VideoTrigger.prototype.init = function () {
    if (!this.video) return;
    this.bind();
  };

  var createInstances = function () {
    nodes.videoTriggers.forEach(function (trigger) {
      new VideoTrigger(trigger);
    });
  };

  window.addEventListener("load", createInstances);
})();

/* Analtytics/Live page - sticky element padding bottom on body so it does not cover footer */
(function () {
  var init, setBodyPaddingBottom, windowOnResize;
  var nodes = {
    stickyElement: document.querySelector("[data-sticky-add]"),
  };

  var windowWidth = window.innerWidth;

  setBodyPaddingBottom = function (value) {
    if (typeof value !== "number") return;
    document.body.style = "padding-bottom:" + value + "px;";
  };

  windowOnResize = function () {
    if (windowWidth === window.innerWidth) return;
    setBodyPaddingBottom(nodes.stickyElement.offsetHeight);
    windowWidth = window.innerWidth;
  };

  init = function () {
    if (!nodes.stickyElement) return;
    setBodyPaddingBottom(nodes.stickyElement.offsetHeight);
    window.addEventListener("resize", windowOnResize);
  };

  init();
})();
